// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_2Um6BeBLtiBAKYXL49hDv-"};